import React from "react";
import Nav from "../components/nav/Nav";
import Footer from "../components/footer/Footer";
import './Faq.css'

function Faq () {
  return(
    <div className="parent-container">
      <Nav />
      <div className="page-content faq-page-content">
        <h1>Return Policy</h1>
        <p>
          We want you to be fully satisfied with your purchase. If you wish to return an item, please carefully read the conditions below:
        </p>

          <h2>Return Period</h2>
        <p>
          You have 14 calendar days from the date you receive your order to return your item.
        </p>

          <h2>Reporting Issues</h2>

        <p>You must contact us within 4 days from the moment you receive your package if:</p>
        <ul className="faq-list">
          <li>The item arrives damaged</li>
          <li>The item is defective</li>
          <li>There is a mistake in your order</li>
          <li>You encounter any other issue with your purchase</li>
        </ul>
        <p>If you report any problem after these 4 days, the return will not be accepted.</p>

        <h2>Product Conditions</h2>
        <p>To be eligible for a return, items must be:</p>
        <ul className="faq-list">
          <li>In their original condition</li>
          <li>Unworn and unused</li>
          <li>With all original packaging and labels intact</li>
        </ul>

        <h2>How to request a return</h2>
        <p>Please contact us by email with the following details:</p>
        <ul className="faq-list">
          <li>Order number</li>
          <li>Item(s) you want to return</li>
          <li>Reason for the return</li>
        </ul>
        <p>We will provide you with instructions and the return address.</p>

        <h2>Return Shipping Costs</h2>
        <p>Return shipping costs are the customer’s responsibility, unless the item is defective or the mistake is on our side.</p>

        <h2>Refunds</h2>
        <p>After we receive and inspect the returned item, your refund will be processed within 5–10 business days, using the same payment method used for the original purchase.</p>




      </div>

      <Footer />
    </div>
  );
};

export default Faq
